<template>
  <iColumn
    v-if="editMode"
    data-test="message-composer-placeholder"
    width="fill"
    height="hug"
  >
    <iText variant="subtle">
      {{ placeholder || "Message composer" }}
    </iText>
  </iColumn>
  <EntityFieldMessageComposer v-else-if="composerProps" v-bind="composerProps" />
</template>

<script>
import EntityFieldMessageComposer from "@bloglovin/inspire-engine/Components/EntityFieldMessageComposer.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { hasCompletePk } from "%/dynamic-component-editor/helpers/complete-pk";
import { mergeEngineContexts, engineCurrentUserPk } from "%/dynamic-component-editor/helpers/engine-current-user";
import { Context } from "%/dynamic-component-editor/classes/context-v2";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import Placeholder from "%/dynamic-component-editor/options/placeholder";
import CommitAction from "%/dynamic-component-editor/options/commit-action";
import StoryComposerWiring from "%/dynamic-component-editor/options/story-composer-wiring";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import { engineWiringProps } from "%/dynamic-component-editor/helpers/engine-wiring-props";

export default {
  name: "MessageComposerElement",
  components: { EntityFieldMessageComposer },
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Message Composer",
    elementGroup: "inputs",
    displayIcon: "mdi:message-text-outline",
    elementType: "element",
  },
  hidden: true,
  options: [Placeholder, CommitAction, StoryComposerWiring],
  optionBundles: [
    new LayoutWidthHeightOptions(),
    new SpacingOptions(),
  ],
  computed: {
    placeholder() {
      return this.getOptionValue(Placeholder) || "";
    },
    entityContextName() {
      return this.elementContext?.entityContext ?? "";
    },
    composerProps() {
      if (!this.contextItem || !this.entityType || !this.entityContextName || !hasCompletePk(this.contextItem.entityPkUrlVars)) {
        return null;
      }
      return {
        ...engineWiringProps("EntityFieldMessageComposer", this.getOptionValue(StoryComposerWiring), `MessageComposerElement ${this.identifier}`),
        contexts: mergeEngineContexts(Context.contexts, this.scopedProvidedContexts?.(), {
          [this.entityContextName]: {
            entityType: this.entityType,
            pk: this.contextItem.entityPkUrlVars,
            appName: this.resolvedAppName,
          },
        }, { currentUserPk: engineCurrentUserPk() }),
        entityContext: this.entityContextName,
        fieldName: this.elementContext?.field ?? "",
        actionName: this.getOptionValue(CommitAction) || "",
        placeholder: this.placeholder,
        appName: this.resolvedAppName,
      };
    },
  },
};
</script>
